<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFecc_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M22.195 14.824 19.219 17.8l-1.414-1.415 2.976-2.976a2 2 0 0 0 0-2.828l-2.976-2.977L19.22 6.19l2.976 2.976a4 4 0 0 1 0 5.658M10.588 3.214 7.612 6.19 6.198 4.776l2.976-2.977a4 4 0 0 1 5.656 0l2.975 2.977-1.414 1.414-2.975-2.976a2 2 0 0 0-2.828 0m-4.39 4.39L4.784 6.19 1.81 9.166a4 4 0 0 0 0 5.658L4.784 17.8l1.414-1.415-2.975-2.976a2 2 0 0 1 0-2.828zm11.607 11.61L16.391 17.8l-2.975 2.976a2 2 0 0 1-2.828 0L7.612 17.8l-1.414 1.414 2.976 2.977a4 4 0 0 0 5.656 0zm-5.803-3.765a3.453 3.453 0 1 0 0-6.907 3.453 3.453 0 0 0 0 6.906"
        clip-rule="evenodd"
    />
</svg>
